module.exports = require('integration/billing/bc3/DefaultBC3AMPIntegration')


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/plugin?payment-instrument!./common/js/src/integration/billing/IntegrationStub.js
// module id = 502
// module chunks = 0